import { useCallback } from "react";

import type { InputMaybe } from "@/lib/gql/__generated__/graphql";

import type { ForNodeType } from "@/components/features/_model/types";

type Props = {
	minimumPeopleNumPerRoom: ForNodeType<number>;
	maxPeopleNumPerRoom: ForNodeType<InputMaybe<number> | undefined> | undefined;

	onSetViewModel: (
		values: {
			key: "minimumPeopleNumPerRoom" | "maxPeopleNumPerRoom";
			value: ForNodeType<InputMaybe<number> | undefined> | undefined;
		}[],
	) => void;
};

export const useMinAndMaxPeopleNumPerRoom = ({
	maxPeopleNumPerRoom,
	minimumPeopleNumPerRoom,
	onSetViewModel,
}: Props) => {
	const onSetMinimumPeopleNumPerRoom = useCallback(
		(input: number | null | undefined) => {
			onSetViewModel([
				{
					key: "minimumPeopleNumPerRoom",
					value: {
						...minimumPeopleNumPerRoom,
						isEdited: minimumPeopleNumPerRoom.isEdited,
						value: input ?? 0,
					},
				},
			]);
		},
		[minimumPeopleNumPerRoom, onSetViewModel],
	);

	const onSetMaxPeopleNumPerRoom = useCallback(
		(input: number | null | undefined) => {
			onSetViewModel([
				{
					key: "maxPeopleNumPerRoom",
					value: {
						...maxPeopleNumPerRoom,
						isEdited: maxPeopleNumPerRoom?.isEdited ?? false,
						value: input,
					},
				},
			]);
		},
		[maxPeopleNumPerRoom, onSetViewModel],
	);

	return {
		minimumPeopleNumPerRoom,
		onSetMinimumPeopleNumPerRoom,
		maxPeopleNumPerRoom,
		onSetMaxPeopleNumPerRoom,
	};
};
